import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import Checkbox from '@material-ui/core/Checkbox';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import WarningIcon from '@material-ui/icons/Warning';
import { Grid } from '@material-ui/core';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { compose } from 'redux';
import moment from 'moment';
import DropdownOrder from './DropdownOrder';
import {
  selectedPaymentPending,
  exportAgent,
  cancelReferenceAgent,
  getAgentsPending
} from '../../../../redux/actions/agentActions';
import GenericTable from './table/GenericTable';
import { isMobile } from 'react-device-detect';
import { downloadXls } from '../../../../libs/utils';
import Spinner from '../../../client/Spinner';

const CustomCheckbox = withStyles({
  root: {
    color: '#2d6df6',
    '&$checked': {
      color: '#2d6df6'
    }
  },
  checked: {}
})(props => <Checkbox color="default" {...props} />);

const styles = theme => ({
  expandedRow: {
    backgroundColor: '#f5f5f5'
  },
  textPolicy: {
    color: '#0033A0'
  },
  textFooter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFF',
    fontSize: '16px',
    width: '68px',
    fontFamily: 'Sura Sans',
    height: '36px',
    borderRadius: '5px',
    fontWeight: 500
  },
  textHead: {
    color: '#888B8D',
    fontSize: '12px',
    fontFamily: 'Sura Sans'
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px 0'
  },
  paginationControls: {
    display: 'flex',
    alignItems: 'center'
  },
  paginationCircles: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    listStyleType: 'none',
    padding: 0,
    margin: isMobile ? '0' : '0 10px'
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  buttonPrimary: {
    width: isMobile ? '100%' : '117px',
    height: isMobile ? '32px' : '40px',
    background: '#0133A0',
    borderRadius: '20px',
    color: '#FFFFFF',
    fontFamily: 'Sura Sans',
    fontSize: '14px',
    fontWeight: 600
  },
  buttonSecondary: {
    width: isMobile ? '100%' : '117px',
    height: isMobile ? '32px' : '40px',
    background: '#E3E828',
    borderRadius: '20px',
    color: '#0133A0',
    fontFamily: 'Sura Sans',
    fontSize: '14px',
    fontWeight: 600
  },
  buttonReference: {
    width: isMobile ? '100%' : '167px',
    height: isMobile ? '32px' : '40px',
    background: '#E3E828',
    borderRadius: '20px',
    color: '#0133A0',
    fontFamily: 'Sura Sans',
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '120%'
  },
  circle: {
    width: 30,
    height: 30,
    margin: '0 5px',
    borderRadius: '50%',
    border: '1px solid #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    color: '#000',
    '&.active': {
      backgroundColor: '#2d6df6',
      color: '#fff',
      borderColor: '#2d6df6'
    }
  },
  paddingHead: {
    padding: 0
  },
  textCenter: {
    display: 'flex',
    alignItems: 'center'
  },
  tablePagination: {
    '& .MuiTablePagination-toolbar': {
      paddingLeft: 0,
      paddingRight: 0
    },
    '& .MuiTablePagination-spacer': {
      display: 'none'
    },
    '& .MuiTablePagination-caption': {
      display: 'none'
    },
    '& .MuiTablePagination-actions': {
      display: 'none'
    }
  },
  warningIcon: {
    color: '#E3E828',
    fontSize: '4rem',
    fontFamily: 'Sura Sans',
    textAlign: 'center',
    display: 'block',
    margin: '0 auto'
  },
  dialogActions: {
    justifyContent: 'center'
  },
  cancelButton: {
    width: '25%',
    height: '40px',
    borderRadius: '20px',
    backgroundColor: '#E0E0E0',
    color: '#000000',
    '&:hover': {
      backgroundColor: '#d5d5d5'
    }
  },
  deleteButton: {
    height: '40px',
    width: '25%',
    borderRadius: '20px',
    backgroundColor: '#0133A0',
    color: '#FFFFFF',
    '&:hover': {
      cursor: 'pointer'
    }
  }
});

const formatValue = (value, formatter = null) => {
  const invalidValues = [null, undefined, '', -1, 'N/A'];
  return invalidValues.includes(value) ? 'N/A' : formatter ? formatter(value) : value;
};

const formatDate = (date, format = 'DD/MM/YYYY') =>
  formatValue(date, (val) => moment(val).format(format));

const calculateTotalmn = (total, currency, currencymn) =>
  currency === 'MXP' ? total * 1 : total * currencymn;

const formatCurrency = (value) =>
  Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const createData = (
  office_id,
  product_id,
  policy_id,
  customer_name,
  issue_date,
  due_date,
  invoice,
  extension_date,
  total,
  currency,
  totalmn,
  currencymn,
  solution,
  group_id,
  subgroup_id,
  reference,
  status,
  bank_reference = '',
  paid_at,
  interest_free_months,
  application_date,
  payment_method,
  uuid,
  policy,
  authorization_code,
  recurring_payment,
  gestor,
  can_domiciliate,
  last_status,
  can_use_check
) => {
  const totalm = calculateTotalmn(total, currency, currencymn);
  const totalFormatted = totalmn || formatCurrency(total);
  const totalmns = totalmn || formatCurrency(totalm);

  return {
    office_id,
    product_id,
    policy_id,
    customer_name,
    issue_date: `Ini. ${formatDate(issue_date)} - Fin. ${formatDate(due_date)}`,
    due_date: formatDate(due_date),
    invoice,
    extension_date: formatDate(extension_date),
    total: totalFormatted,
    currency,
    totalmn: totalmns,
    solution,
    group_id,
    subgroup_id,
    reference,
    status,
    bank_reference,
    paid_at: formatDate(paid_at),
    interest_free_months: formatValue(interest_free_months),
    application_date: formatDate(application_date),
    payment_method: formatValue(payment_method),
    uuid,
    policy: `${office_id} - ${product_id} - ${policy_id}`,
    authorization_code,
    recurring_payment,
    gestor,
    can_domiciliate,
    last_status,
    can_use_check
  };
};

const PaymentTable = props => {
  const history = useHistory();

  const {
    classes,
    isPending,
    withCheckbox,
    withActions,
    selectedPaymentPending,
    selectedData,
    isDataComplete,
    infoAgent,
    pending,
    currentPagePending,
    currentRecordsPending,
    paymentToken,
    totalPagesPending,
    getDataTable,
    totalRecordsPending,
    type,
    isLoading,
    setIsLoading,
    exportAgent,
    currencymn,
    handleOrderChange,
    cancelReferenceAgent,
    orderParams,
    filters,
    getAgentsPending,
    setOrderParams,
    setShowCancellationMessage
  } = props;

  const [selectedRows, setSelectedRows] = useState(selectedData.map(item => item.invoice));
  const [selectedReferences, setSelectedReferences] = useState([]);
  const [page, setPage] = useState(0);
  const [tableData, setTableData] = useState(type === 'summary' ? [] : pending);
  const [openModal, setOpenModal] = useState(false);
  const [loadingExport, setLoadingExport] = useState(false);

  const exportXls = async (agent_id, type, paymentToken) => {
    setLoadingExport(true);
    
    const getFormattedDate = () => {
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const year = today.getFullYear();
      return `${day}${month}${year}`;
    };
    const typeMap = {
      pending: `RecibosPendientes_${agent_id ? agent_id + '_' : ''}${getFormattedDate()}`,
      paid_unapplied: `RecibosPagadosPenAplicar_${agent_id ? agent_id + '_' : ''}${getFormattedDate()}`,
      paid_applied: `RecibosPagadosAplicados_${agent_id ? agent_id + '_' : ''}${getFormattedDate()}`,
      referenced_payments: `RecibosPendientesReferenciados_${agent_id ? agent_id + '_' : ''}${getFormattedDate()}`
    };

    try {
      const fileName = typeMap[type];
      const xlsResponse = await exportAgent(agent_id, type, fileName, paymentToken);
    } catch (error) {
      console.error('Error al exportar:', error);
    } finally {
      setLoadingExport(false);
    }
  };
  useEffect(() => {
    const updatedSelection = rows.filter(row => selectedRows.includes(row.invoice));
    selectedPaymentPending(updatedSelection);
  }, [selectedRows]);
  useEffect(() => {
    if (selectedData.length > 0) {
      const selectedInvoices = selectedData.map(item => item.invoice);
      setSelectedRows(selectedInvoices);
    }
    if (isDataComplete) {
      setTableData(selectedData);
    }
  }, []);

  const handleExpandClick = () => {
    if (selectedRows.length === 0) {
      return;
    }
    history.push(`/cobranza/pago`);
    localStorage.removeItem('selectedOrderOption');
  };

  const handleSelect = selected => {
    setSelectedRows(selected);
    if (type === 'referenced_payments') setSelectedReferences(selected);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
    const updatedSelected = selectedData.map(item => item.invoice);
    setSelectedRows(updatedSelected);
  };

  const handleRowsPerPageChange = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleDeleteReferences = async () => {
    const jason = { references: selectedReferences };
    await cancelReferenceAgent(paymentToken, jason);
    handleCloseModal();
    const params = {
      ...orderParams,
      ...filters.searchValues,
      selectedFilters: filters.selectedFilters
    };
    const cdAgente = infoAgent ? infoAgent.cdAgente : null;
    getAgentsPending(
      JSON.parse(localStorage.getItem('currentPage')),
      JSON.parse(localStorage.getItem('rowsPerPage')),
      cdAgente,
      'referenced_payments',
      paymentToken,
      params
    );
  };
  const rows = tableData
    .filter(item => typeof item === 'object')
    .flatMap(item =>
      item.receipts
        ? item.receipts.map(receipt =>
            createData(
              receipt.office_id,
              receipt.product_id,
              receipt.policy_id,
              receipt.customer_name,
              receipt.issue_date,
              receipt.due_date,
              receipt.invoice,
              receipt.extension_date,
              receipt.total,
              receipt.currency,
              receipt.totalmn || null,
              currencymn,
              receipt.solution,
              receipt.group_id,
              receipt.subgroup_id,
              receipt.reference,
              receipt.status,
              item.bank_reference,
              item.paid_at,
              item.interest_free_months,
              item.application_date,
              item.payment_method,
              item.uuid,
              item.policy,
              item.authorization_code,
              receipt.recurring_payment,
              receipt.gestor,
              receipt.can_domiciliate,
              item.last_status,
              receipt.can_use_check
            )
          )
        : createData(
            item.office_id,
            item.product_id,
            item.policy_id,
            item.customer_name,
            item.issue_date,
            item.due_date,
            item.invoice,
            item.extension_date,
            item.total,
            item.currency,
            item.totalmn || null,
            currencymn,
            item.solution,
            item.group_id,
            item.subgroup_id,
            item.reference,
            item.status,
            item.bank_reference,
            item.paid_at,
            item.interest_free_months,
            item.application_date,
            item.payment_method,
            item.uuid,
            item.policy,
            item.authorization_code,
            item.recurring_payment,
            item.gestor,
            item.can_domiciliate,
            item.last_status,
            item.can_use_check
          )
    );

  useEffect(() => {
    const selectedarray = tableData.filter(item => selectedRows.includes(item.invoice));
    const combinedSelectedData = [
      ...selectedData.filter(item => !selectedarray.some(sel => sel.invoice === item.invoice)),
      ...selectedarray
    ];
    selectedPaymentPending(combinedSelectedData);
  }, [selectedRows]);
  const columns = [
    { key: 'office_id', label: 'Oficina, Ramo, Póliza' },
    { key: 'customer_name', label: 'Nombre contratante' },
    { key: 'issue_date', label: 'Vigencia' },
    { key: 'invoice', label: 'Recibo' },
    { key: 'extension_date', label: 'Fecha límite de pago' },
    { key: 'total', label: 'Importe MO' },
    { key: 'currency', label: 'Moneda' },
    { key: 'totalmn', label: 'Importe MN' }
  ];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', minHeight: '770px' }}>
      <Grid
        container
        justify="space-between"
        style={{ paddingTop: isMobile ? '0' : '1rem ', gap: '10px', width: '100%' }}
      >
        {type !== 'summary' && (
          <React.Fragment>
            <div
              style={{
                display: 'flex',
                gap: '1rem',
                width: isMobile ? '80%' : '100%',
                paddingLeft: isMobile ? '0' : '40px',
                ...(isMobile ? { position: 'absolute', top: type === 'paid_applied' ? '236px' : '262px', left: '50%', transform: 'translateX(-50%)' } : {})
              }}
            >
              {' '}
              {!isMobile && <DropdownOrder onOrderChange={handleOrderChange} type={type} isLoading={isLoading} />}
              <Button
                style={{ textTransform: 'none' }}
                className={classes.buttonPrimary}
                onClick={() => exportXls(infoAgent.cdAgente, type, paymentToken)}
                type="submit"
                disabled={isLoading || loadingExport}
              >
                {loadingExport ? <Spinner /> : 'Descargar'}
              </Button>
              {withCheckbox && (
                <Button
                  size="medium"
                  style={{ textTransform: 'none' }}
                  className={classes.buttonSecondary}
                  onClick={handleExpandClick}
                  disabled={selectedRows.length === 0 || isLoading}
                >
                  Continuar
                </Button>
              )}
              {type === 'referenced_payments' && (
                <Button
                  size="medium"
                  style={{ textTransform: 'none' }}
                  className={classes.buttonReference}
                  onClick={handleOpenModal}
                  disabled={selectedRows.length === 0 || isLoading}
                >
                  Cancelar referencias
                </Button>
              )}
            </div>
          </React.Fragment>
        )}
      </Grid>

      <GenericTable
        selectedReferences={selectedReferences}
        orderParams={orderParams}
        isLoading={isLoading}
        type={type}
        withActions={withActions}
        isPending={isPending}
        columns={columns}
        setIsLoading={setIsLoading}
        rows={rows}
        selectedRows={selectedRows}
        onSelect={handleSelect}
        currentPage={currentPagePending}
        getDataTable={getDataTable}
        totalRecordsPending={totalRecordsPending}
        totalPagesPending={totalPagesPending}
        withCheckbox={withCheckbox}
        currentRecordsPending={currentRecordsPending}
        page={page}
        onPageChange={handlePageChange}
        totalSum={selectedData
          .filter(item => typeof item === 'object')
          .reduce((acc, row) => {
            if (row && row.currency) {
              const totalmn = row.currency === 'USD' ? row.total * currencymn : row.total;
              const totalRounded = Math.round(totalmn * 100) / 100;
              return acc + totalRounded;
            }
            return acc;
          }, 0)}
        paymentToken={paymentToken}
        setOrderParams={setOrderParams}
        setShowCancellationMessage={setShowCancellationMessage}
      />

      <Dialog
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
      >
        <div style={{ padding: '1rem' }}>
          <WarningIcon className={classes.warningIcon} />
          {selectedReferences.length === 0 && (
            <React.Fragment>
              <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {'No existe ninguna referencia seleccionada'}
              </DialogTitle>
              <DialogActions className={classes.dialogActions}>
                <Button onClick={handleCloseModal} className={classes.cancelButton}>
                  Cerrar
                </Button>
              </DialogActions>
            </React.Fragment>
          )}
          {selectedReferences.length > 0 && (
            <React.Fragment>
              <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {'¿Estás seguro de continuar?'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description" style={{ textAlign: 'center' }}>
                  Estas seguro de cancelar las referencias:{' '}
                  {selectedReferences.map((reference, index) => (
                    <span key={index}>
                      {reference}
                      {index < selectedReferences.length - 1 && ','}{' '}
                    </span>
                  ))}
                  . Una vez canceladas, los recibos regresarán al tab de recibos pendientes de pago.
                </DialogContentText>
              </DialogContent>
              <DialogActions className={classes.dialogActions}>
                <Button onClick={handleCloseModal} className={classes.cancelButton}>
                  Cancelar
                </Button>
                <Button onClick={handleDeleteReferences} className={classes.deleteButton}>
                  Eliminar
                </Button>
              </DialogActions>
            </React.Fragment>
          )}
        </div>
      </Dialog>
    </div>
  );
};
const mapStateToProps = state => ({
  account: get(state, 'account'),
  selectedData: get(state, 'agentReducer.selected', []),
  currentPagePending: state.agentReducer.currentPagePending,
  currentRecordsPending: state.agentReducer.currentRecordsPending,
  paymentToken: state.agentReducer.paymentToken,
  pending: state.agentReducer.pending,
  infoAgent: state.agentReducer.infoAgent,
  totalPagesPending: state.agentReducer.totalPagesPending,
  totalRecordsPending: state.agentReducer.totalRecordsPending,
  currencymn: state.agentReducer.currency
});

const mapDispatchToProps = {
  selectedPaymentPending,
  exportAgent,
  cancelReferenceAgent,
  getAgentsPending
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(PaymentTable);


// WEBPACK FOOTER //
// ./src/containers/agent/Tabs/Payments/PaymentTable.js